import { gql } from "@apollo/client"

export const GET_LAUNCHES = gql`
  query GetLaunches($limit: Int) {
    launches(limit: $limit) {
      id
      mission_name
      launch_date_local
      launch_success
      rocket {
        rocket_name
        rocket_type
      }
      links {
        mission_patch_small
        article_link
      }
    }
  }
`

export const GET_LAUNCH_BY_ID = gql`
  query GetLaunchById($id: ID!) {
    launch(id: $id) {
      id
      mission_name
      mission_id
      launch_date_local
      launch_success
      details
      rocket {
        rocket_name
        rocket_type
      }
      links {
        mission_patch
        article_link
        wikipedia
      }
    }
  }
`

export const GET_ROCKETS = gql`
  query GetRockets {
    rockets {
      id
      name
      type
      active
      stages
      boosters
      cost_per_launch
      success_rate_pct
      first_flight
      country
      company
      description
    }
  }
`

export const HEROES = gql`
query ActiveHeroes {
  activeHeroes {
    id
    title
    subtitle
    ctaText
    ctaLink
    type
    mediaUrl
    order
  }
}
`
